import gql from 'graphql-tag';

export default gql`
query GetMyEndpoint(
        $uuid: String!
        ) {
    getMyEndpoint(
        uuid: $uuid
    ) {
        uuid
        user
        app    # that the endpoint belongs to

        # Tags
        tag1
        tag2
        tag3
        tag4
        tag5

        # Endpoint info
        name
        desc
        images
    }
}
`;
